/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import { SurveySummary, SurveyType } from '../../types/survey';
import SimpleTooltip from '../simple-tooltip';
import { QUESTION } from '../../constants/terminology';

const SurveyIcon = ({ survey }: { survey: Pick<SurveySummary, 'type' | 'status' | 'completedDate' > }) => {

  const isCombinedReport = survey.type === SurveyType.Aggregation;
  const hasRejected = survey.status.rejected > 0;
  const isCompleted = Boolean(survey.completedDate);

  const icon = (() => {
    if (isCompleted) {
      return 'fa-lock';
    }
    if (isCombinedReport) {
      return 'fa-object-exclude';
    }
    return 'fa-circle';
  })();

  const color = (() => {
    if (hasRejected) {
      return 'text-ThemeDangerMedium';
    }
    if (isCombinedReport) {
      return 'text-ThemeAccentExtradark';
    }
    if (isCompleted) {
      return 'text-ThemeSuccessMedium';
    }
    return 'text-ThemeTextPlaceholder';
  })();

  const tooltip = (() => {
    switch (true) {
      case hasRejected:
        return `This report has rejected ${QUESTION.PLURAL} that need to be reviewed`;
      case isCombinedReport:
        return 'This is a combined report';
      case isCompleted:
        return 'This report is completed';
      default:
        return 'This report is in progress';
    }
  })();

  return (
    <SimpleTooltip text={tooltip}>
      <i className={`fas ${icon} ${color}`} />
    </SimpleTooltip>
  );
}

export default SurveyIcon;
